<template>
    <div v-if="$auth.status" class="balance-and-exp-sec">
        <div class="balance-sec">
            <span> {{ $t('balance','Balance')}} : &nbsp; <strong>{{ $helper.formatNumber($auth.user.balance) }}</strong></span>
        </div>
        
        <div class="exp-sec">
            <span>{{$t('exp', 'Exp')}}: &nbsp; <strong>{{$helper.formatNumber($auth.user.expl ? (-1)*$auth.user.expl : 0)  }}</strong></span>
            <a href="Javascript:void(0);" @click="getWalletGetway()" class="tiger-main-header-wallet" v-if="$siteSettings?.data?.business_type == 2">{{ $t('wallet','Wallet')}}</a>
            <a data-bs-toggle="offcanvas" href="#offcanvasmenu" role="button" aria-controls="offcanvasExample" class="tiger-main-header-account">{{ $t('account','Account')}}</a>
        </div>
    </div>
    
    <div class="nav-bar-toggle header-navbar" v-if="showMainHeader()">
        <div class="inply-main-logo">
            <img @click="gotoHome()" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path?.domain_image + $siteSettings?.data?.logo" alt="logo">
        </div>
        <div class="side-bar-trigger" v-if="$auth?.status">
            <a data-bs-toggle="offcanvas" href="#offcanvasmenu" role="button" aria-controls="offcanvasmenu" aria-label="Side Bar Btn">
                <i><img src="@/assets/images/menu_bar.svg"></i>
            </a>
        </div>
        <div class="deposit-withdraw-btn" v-if="!$auth?.status">
            <div class="d-w-btns">
                <ul class="d-w-list">
                    <li>
                        <a class="btn" @click="$emit('toggleLogin')">{{$t('login', 'Login')}}</a>
                    </li>
                    <li v-if="$siteSettings?.data?.business_type == 2">
                        <a class="btn withdraw-btn" @click="$emit('toggleRegister')">{{$t('register', 'Register')}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="deposit-withdraw-btn" v-if="$siteSettings?.data?.business_type == 2 && $auth?.status">
            <div class="d-w-btns">
                <ul class="d-w-list">
                    <li>
                        <a class="btn" href="Javascript:void(0);" @click="goToWalletDeposit()">{{$t('deposit', 'Deposit')}}</a>
                    </li>
                    <li>
                        <a class="btn withdraw-btn" href="Javascript:void(0);" @click="goToWalletWithdraw()">{{$t('withdraw', 'Withdraw')}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- <a href="Javascript:void(0);" @click="getWalletGetway()" class="tiger-mobile-wallet" v-if="$siteSettings?.data?.business_type == 2"  aria-label="Open Wallet">
            <img loading="lazy" src="@/assets/images/wallet.webp" alt="wallet">
        </a>  -->
    </div>
    <div class="nav-bar-toggle" v-else>
        <div class="inply-main-logo">
            <span >{{$t(headName()?.toLowerCase()?.replace(/'/g, '')?.trim()?.replace(/\s+/g, '-'), headName())}}</span>
        </div>
        <div class="side-bar-trigger">
            <a data-bs-toggle="offcanvas" href="#offcanvasmenu" role="button" aria-controls="offcanvasmenu" aria-label="Side Bar Btn">
                <i><img src="@/assets/images/menu_bar.svg"></i>
            </a>
        </div>
        <!-- <a href="Javascript:void(0);" @click="getWalletGetway()" class="tiger-mobile-wallet" v-if="$siteSettings?.data?.business_type == 2" aria-label="Open Wallet">
            <img loading="lazy" src="@/assets/images/wallet.webp" alt="wallet">
        </a> -->
    </div>
    <div class="moving-text-sec" v-if="$siteSettings?.data && $siteSettings?.data.announcement && $siteSettings?.data.announcement.msg">
        <marquee :style="{ color: $siteSettings?.data?.announcement?.color_code }" behavior="scroll" direction="" scrollamount="5" onmouseover="this.stop();" onmouseout="this.start();">
           {{$siteSettings?.data.announcement.msg}}
        </marquee>
    </div>
    <div class="demodev" v-if="$auth.user?.isDemoLogin">
        <button class="demo_login">{{ $t('demo-account', 'Demo Account') }}</button>
    </div>
    <div class="tabs-fixed-width-sec">
        <div class="tabs-list">
            <ul v-if="this.$route.name=='Inplay' || this.$route.name=='sports' || this.$route.name=='Featured'">
                <li v-for="(sport, n_index) in primary_non_custom_sports" :key="n_index"
                    @click="set_tab(sport.id), currentTab = sport.id">
                    <router-link :to="{ name: 'sports', params: { type: sport.slug, id: sport.id } }"
                        :class="{ 'active': $route.params.id == sport.id }">
                        <img loading="lazy" :src="getSportImage(sport.id)" alt=""> 
                        <div class="tabs-text">
                            <span> {{ sport.name == 'soccer' ? $t('football' ,'Football' ):  $t(sport.slug,sport.name) }} </span>
                        </div>
                        <div class="game-count">{{ total_matches?.[sport.id]?.total ?? 0}}</div>
                    </router-link>
                </li>
                <li >
                    <router-link to="/cricket-fight">
                        <img loading="lazy" src="@/assets/images/cricket_fight.png" alt="cricket-bat">
                        <div class="tabs-text">
                            <span>{{ $t('cricket-fight','Cricket Fight')}}</span>                           
                        </div>
                    </router-link>
                </li>
                <li v-if="checkEventManageforSingleType('sports-book')">
                    <router-link :to="{ name: 'SportsBook' }">
                        <img loading="lazy" src="@/assets/images/sportsbook-icon.webp" alt="sportsbook-icon">
                        <div class="tabs-text">
                            <span>{{ $t('sportsbook','SportsBook')}}</span>                           
                        </div>
                    </router-link>
                </li>
                <li v-if="checkEventManageforSingleType('worli-matka')">
                    <router-link to="/matka">
                        <img loading="lazy" src="@/assets/images/matka-img-new.png" alt="matka-icon">
                        <div class="tabs-text">
                            <span>{{ $t('matka','Matka')}}</span>
                        </div>
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'Games', params: { type: 'casino'} }">
                        <img loading="lazy" src="@/assets/images/casino-icon.webp" alt="casino-icon">
                        <div class="tabs-text">
                            <span>{{ $t('casino','Casino')}}</span>
                        </div>
                    </router-link>
                </li>

                <li>
                    <router-link :to="{ name: 'Games', params: { type: 'evolution'} }">
                        <img loading="lazy" src="@/assets/images/int-casino.webp" alt="evolution">
                        <div class="tabs-text">
                            <span>Int {{ $t('evolution','Evolution')}}</span>
                        </div>
                    </router-link>
                </li>
                <li v-for="(sport, n_index) in secondary_non_custom_sports" :key="n_index"
                    @click="set_tab(sport.id), currentTab = sport.id">
                    <router-link :to="{ name: 'sports', params: { type: sport.slug, id: sport.id } }"
                        :class="{ 'active': $route.params.id == sport.id }">
                        <img loading="lazy" :src="getSportImage(sport.id)" alt=""> 
                        <div class="tabs-text">
                            <span> {{ $t(sport.slug, sport.name) }} </span>
                        </div>
                        <div class="game-count">{{ total_matches?.[sport.id]?.total ?? 0}}</div>
                    </router-link>
                </li>
                <li v-for="(c_sport, c_index) in custom_sports" :key="c_index"
                    @click="set_tab(c_sport.id), currentTab = c_sport.id">
                    <router-link :to="{name:'sports', params:{type: c_sport.slug,id:c_sport.id} }" :class="{ 'active': $route.params.id == c_sport.id }">
                       
                            <img loading="lazy" :src="getSportImage(c_sport.id)" alt=""> 
                        <div class="tabs-text">
                            <span> {{ $t(c_sport.slug,c_sport.name)}} </span>                           
                        </div>
                        <div class="game-count">{{ total_matches?.[c_sport.id]?.total ?? 0}}</div>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
    <Offers />
    <UserIdModal />
</template>

<script>
// import Inplay from '@/modules/sports/views/Inplay.vue';
import { defineAsyncComponent } from 'vue';
import { mapGetters } from "vuex";
export default {
    name: 'MainHeader',
    components: {
        UserIdModal: defineAsyncComponent(() => import('@/shared/components/modal/UserIdModal.vue') ),
        Offers: defineAsyncComponent(() => import('@/shared/components/modal/Offers.vue'))
    },
    data() {
        return {
            isVisible: false,
            non_custom_sports: [],
            custom_sports: [],
            currentTab: 'inplay',
            matches: null,
            clickApiUrl: process.env.VUE_APP_CLICK_API + 'v1/aws-s3/download/',
            total_matches:null,
            eventManage: null
        }
    },
    computed:{
        ...mapGetters(['logInData']),
        inplayCount(){
            var sum=0;
            for(var data in this.total_matches ){
                sum+=this.total_matches[data].inplay
            }
            return sum
        },
        sortedNonCustomSports() {
            const order = ['cricket', 'football', 'tennis'];
            return this.non_custom_sports.sort((a, b) => {
                const aIndex = order.indexOf(a.name.toLowerCase());
                const bIndex = order.indexOf(b.name.toLowerCase());

                if (aIndex !== -1 || bIndex !== -1) {
                return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
                }
                return a.rank - b.rank;
            });
        },
        primary_non_custom_sports(){
            return this.$store.getters.sports_list?.non_custom?.filter(sport => [1,2,3,4].includes(sport.rank))?.sort((a, b) => [1, 3, 4].indexOf(a.rank) - [1, 3, 4].indexOf(b.rank))
        },
        secondary_non_custom_sports(){
            return this.$store.getters.sports_list?.non_custom?.filter(sport => ![1,2,3,4].includes(sport.rank))
        },
    },
    created() {
        this.get_sportsList();
        this.eventManage = this.$store?.getters?.eventManage;
    },
    mounted() {
        this.matches = JSON.parse(localStorage.getItem('Matches'))
        this.getTotalMatches();
        this.callOfferPage();
    },
    methods: {

        headName() {
            let routeName = this.$route.name;
                switch (routeName) {
                    case 'AccountStatement':
                        return 'Account Statement';
                    case 'profit-loss':
                        return 'Profit Loss'
                    case 'settled-bets':
                        return 'Settled Bets'
                    case 'wallet-deposit':
                        return 'Deposit';
                    case 'Terms':
                        return 'Terms';
                    case 'wallet-withdraw':
                        return 'WITHDRAWAL';
                    case 'deposit-payment-method':
                        return 'Deposit Payment Method';
                    case 'bonus':
                        return 'BONUS';
                    case 'refer-earn':
                        return 'REFER AND EARN';
                    case 'unsettled-bets':
                        return 'UNSETTLED BETS'
                    case 'MultiMarket':
                        return 'MULTI MARKET';
                    case 'Profile':
                        return 'PROFILE';
                    case 'Rules':
                        return 'RULES';
                    case 'EditStakes':
                        return 'EDIT STAKES';
                    case 'MainTerms':
                        return 'TERMS & CONDITIONS';
                    case 'Notifications':
                        return 'Notifications'

            }
        },
        // betSlip() {
        //     if (!this.isVisible) {
        //         var bets = document.getElementById('bets-detail');
        //         console.log("chek",bets)
        //         if(bets.style.display==='none'|| bets.style.display===''){
        //             bets.style.display='block';
        //         }
        //         else {
        //             bets.style.display="none"
        //         }
        //         this.isVisible = true
        //     }
        //     // $(".bets-details-in-mobile").toggle();
        //     // $(".book-maker-section").css("display", "none");
        // },
        // marketShow() {
        //     if (this.isVisible) {
        //         var bets_details_in_mobile = document.getElementById('bets-detail')
        //         console.log("check element", bets_details_in_mobile)
        //         if (bets_details_in_mobile.style.display === 'none' ||
        //             bets_details_in_mobile.style.display === "") {
        //             bets_details_in_mobile.style.display = "block"
        //         }
        //         else {
        //             bets_details_in_mobile.style.display = "none"
        //         }
        //         this.isVisible = false
        //         // $(".bets-details-in-mobile").toggle();
        //         // this.isVisible = false
        //     }
        //     // $(".book-maker-section").css("display", "block");
        // },
        // showTv() {
        //     // $("#live-tv-pin").toggle();
        //     var liveTvPin = document.getElementById("live-tv-pin");
        //     if (
        //         liveTvPin.style.display === "none" ||
        //         liveTvPin.style.display === ""
        //     ) {
        //         liveTvPin.style.display = "block";
        //     } else {
        //         liveTvPin.style.display = "none";
        //     }
        // },
        checkEventManageforSports(sportId) {
            if(this.$auth.status) {
                let sportEventManage = this.eventManage.find(item => item.type == 'sports');
                if(sportEventManage) {
                    let sportIds = sportEventManage.type_id.split(',');
                    return !sportIds.includes(sportId.toString());
                }
            }
            return true;    
        },
        checkEventManageforSingleType(type) {
            if(this.$auth.status) {
                let sportEventManage = this.eventManage.find(item => item.type == type);
                if(type == 'worli-matka' && sportEventManage && sportEventManage.type_id != null ) {
                    return true
                }
                return !sportEventManage
            }
            return true;    
        },
        get_sportsList() {
            this.loading = true;
            this.$apiCall('get', 'GET_SPORTS', null, 'sports').then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        var all_sports = response.data.data
                        this.non_custom_sports = []
                        for (var i = 0; i < all_sports.length; i++) {
                            if(this.checkEventManageforSports(all_sports[i].id)) {
                                if (all_sports[i].is_custom == 0) {
                                    this.non_custom_sports.push(all_sports[i])
                                } else {
                                    this.custom_sports.push(all_sports[i])
                                }
                            }
                        }
                        this.non_custom_sports.sort((a, b) => {
                            return a.rank - b.rank;
                        });

                        var sport_list = {}
                        sport_list['custom'] = this.custom_sports
                        sport_list['non_custom'] = this.sortedNonCustomSports
                        this.$store.dispatch('setSportsList',sport_list);
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    console.log("Error : ", error);
                    // this.showErrorModalFunc(error.data.message);
                }
            });
        },
        getTotalMatches(){
            this.loading=true;
            this.$apiCall('get', 'INPLAY_MATCHES_COUNT', null, 'sports').then(response=>{
                this.loading=false;
                if(response){
                    if(response.status==200){
                        this.total_matches=response.data.data
                    }
                }
            })
        },
        set_tab(name) {
            this.$store.commit('set_sport_tab', name)
            // this.$router.push('/home')
        },
        getWalletGetway() {
            this.$router.push({name: 'wallet-deposit'});
        },
        goToWalletDeposit() {
            this.$router.push({ name: 'wallet-deposit' });
        },
        goToWalletWithdraw() {
            this.$router.push({ name: 'wallet-withdraw' });
        },
        getSportImage(sportId) {
            const imageMap = {
                4: require("@/assets/images/icon-cricket.webp"),
                1: require("@/assets/images/icon-football.webp"),
                2: require("@/assets/images/icon-tennis.webp"),
                1477: require("@/assets/images/sports-rugby-league.png"),
                6: require("@/assets/images/sports-boxing.png"),
                5: require("@/assets/images/sports-rugby-union.png"),
                3: require("@/assets/images/sports-golf.png"),
                27454571: require("@/assets/images/sports-esports.png"),
                2152880: require("@/assets/images/sports-gaelic-football.png"),
                998917: require("@/assets/images/sports-volleyball.png"),
                7524: require("@/assets/images/sports-ice-hockey.png"),
                7522: require("@/assets/images/sports-basketball.png"),
                7511: require("@/assets/images/sports-baseball.png"),
                6423: require("@/assets/images/sports-american-football.png"),
                6422: require("@/assets/images/sports-snooker.png"),
                11: require("@/assets/images/sports-cycling.png"),
                8: require("@/assets/images/sports-motor-sport.png"),
                2378961: require("@/assets/images/sports-politics.png"),
                468328: require("@/assets/images/sports-handball.png"),
                61420: require("@/assets/images/sports-australian-rules.png"),
                3503: require("@/assets/images/sports-darts.png"),
                10: require("@/assets/images/sports-special-bets.png"),
                26420387: require("@/assets/images/sports-mixed-martial-arts.png"),
                4339: require("@/assets/images/sports-greyhound-racing.png"),
                7: require("@/assets/images/sports-horse-racing.png"),
            };
            return imageMap[sportId] || require("@/assets/images/sports-no.png");
        },
        gotoHome() {
            this.$router.push({name: 'Home'});
        },
        callOfferPage(){
            if(this.logInData.userIds.includes(this.$auth?.user?.userid)) {
                setTimeout(()=>{
                    let is_offer = localStorage.getItem("is_offer");
                    if (this.$auth.status && this.$siteSettings.data.offer != null && is_offer == null && this.$siteSettings?.data?.business_type == 2) {
                        this.$helper.openModal("#offer_pop_up");
                    }
                },500)
            }
        },
        showMainHeader() {
            const routeNames = ['Inplay', 'sports', 'SportsEventDetail', 'MultiMarket', 'matka', 'matka-details', 'CricketFight', 'MatchDetails', 'PlaceBet', 'MyContests', 'MyContestBetDetails', 'casino', 'int-casino'];
            return routeNames.includes(this.$route.name)
           || (this.$route.name === 'Games' && (this.$route.params?.type === 'evolution' || this.$route.params?.type === 'casino'));
        }
    },
}
</script>

<style scoped>
.d-w-list{
    margin-left:-5px;
    margin-right:-5px;
    list-style: none;
}
.d-w-list li {
    padding-left: 5px;
    padding-right: 5px;
    width: 50%;
    float: left;
}
.d-w-list .btn{
    border-radius: 5px;
    padding: 4px 15px;
    color: #ffffff !important;
    background-color: #ffa143;
    width: 100%;
    margin: 0;
}
.deposit-withdraw-btn {
    width: 100%;
    padding: 5px;
}
.d-w-list .btn.withdraw-btn {
    background-color: #657e95;
}
</style>